import "./styles.css";

import logo_topo from "../../assets/logo_topo.png";
import CtaMenu from "../CtaMenu";

const Menu = () => {
  return (
    <nav id="menu">
      <section className="container">
        <figure className="left">
          <img src={logo_topo} alt="Logo" />
        </figure>

        <CtaMenu />
      </section>
    </nav>
  );
};

export default Menu;
